import React from 'react';
import { useParams } from 'react-router-dom';
import { AssetHandler } from './components/AssetHandler';
import { SoundHandler } from './components/SoundHandler';
import BlinkoReplay from './BlinkoReplay';

const ReplayPage: React.FC = () => {
  const { gameId } = useParams();

  if (!gameId) { 
      // Should not happen with route /replay/:gameId
      return null;
  }

  return (
    <AssetHandler>
      <SoundHandler />
      {/* Intentionally omitting MetadataHandler and PlayResultHandler for replay */}
      <BlinkoReplay replayGameId={gameId} />
    </AssetHandler>
  );
};

export default ReplayPage;
